import React from 'react';
import { Table, ButtonGroup, Button } from 'react-bootstrap';

const OffersTable = ({ offers, onUpdate, onDuplicate, onRemove }) => {
    const rows = offers.map(({ id, source, country, language, device, title, body, icon, image, url, cpc, closeUrl, closeCpc, blockUrl, blockCpc }) => {
        return (
            <tr key={id}>
                <td>{id}</td>
                <td>{source}</td>
                <td>{device}</td>
                <td>{country && country.join(',')}</td>
                <td>{language && language.join(',')}</td>
                <td>{title}</td>
                <td>{body}</td>
                <td>{icon}</td>
                <td>{image}</td>
                <td>{url}</td>
                <td>{cpc}</td>
                <td>
                    <ButtonGroup>
                        <Button bsStyle="info" onClick={() => onUpdate(id)}>Update</Button>
                        <Button bsStyle="info" onClick={() => onDuplicate(id)}>Duplicate</Button>
                        <Button bsStyle="danger" onClick={() => onRemove(id)}>Remove</Button>
                    </ButtonGroup>
                </td>
            </tr>
        );
    });

    return (
        <Table bordered responsive>
            <thead>
            <tr>
                <th>ID</th>
                <th>Source</th>
                <th>Device</th>
                <th>Country</th>
                <th>Language</th>
                <th>Title</th>
                <th>Body</th>
                <th>Icon</th>
                <th>Image</th>
                <th>URL</th>
                <th>CPC</th>
                <th>Actions</th>
            </tr>
            </thead>
            <tbody>
            {rows}
            </tbody>
        </Table>
    );
};

export default OffersTable;


// WEBPACK FOOTER //
// ./src/scenes/BidderManualOffers/components/OffersTable/index.js